export default __webpack_public_path__ + "static/media/Ecommerce shop.a1b5644e.png";